<template>
	<GBRightPane
		v-bind:display="display"
		v-on:close="onClose"
	>
		<GBModalVScrollable class="project-info"
			title="案件の表示項目変更"
			header_height="115"
			bottom_height="0"
			v-on:close="onClose"
		>
			<template v-slot:header>
				<div class="modal-header-member-info">
					<v-btn flat blue large color="white" v-on:click.stop="onClickDone">完了</v-btn>
					<v-btn flat blue large color="white" v-on:click="onClickClear">クリア</v-btn>
				</div>
			</template>
			<template v-if="value">
				<v-layout wrap mx-4 pr-2>
					<v-form ref="form-project-info">
						<v-checkbox
							v-model="value.items[type.CLASS][pinned_id_class]"
							label="分類"
							></v-checkbox>
						<v-checkbox
							v-for = "info in additionalInfo"
							v-bind:key="info.code"
							v-model="value.items[type.ADDTIONAL][info.code]"
							v-bind:label="info.name"
							></v-checkbox>
					</v-form>
				</v-layout>
			</template>
		</GBModalVScrollable>
	</GBRightPane>
</template>
<script>
import GBRightPane from './GBRightPane';
import GBModalVScrollable from './GBModalVScrollable';
import Notification from '../classes/Notification';
import Util from '../classes/Util';
import DataSetManager from '../classes/DataSetManager';
import ProjectPinned from '../data/ProjectPinned';

export default {
	name: 'GBRightPaneProjectPenned',
	props: [
		"value",
		"fetch",
	],
	components: {
		GBRightPane,
		GBModalVScrollable,
	},
	data: function() {
		return {
			dataset_manager: this.$store.getters.datasetManager,
			type: ProjectPinned.TYPE,
			pinned_id_class: ProjectPinned.PINNED_ID_CLASS
		};
	},
	methods: {
		onClose: function() {
			this.$emit('close');
		},
		onClickDone: function() {
			this.$store.dispatch('updateProjectPinned', this.value).then((res) => {
				if (res) {
					const onFail = async (err) => {
						const callback = {
							401: () => {
								this.logout();
							},
							409: () => {
								this.onClose();
							},
						};
						Util.updateFail(this.$store, err.response, callback);
						
						this.fetchData();
					};
					const onTokenFail = () => {
						this.logout();
					};
					
					this.dataset_manager.setAfterDataset();
					this.dataset_manager.syncProjectPinned(null, onFail, onTokenFail);
				}
				else {
					this.$store.commit('addNotification', Notification.error('更新に失敗しました', ''));
				}
			});
			
			this.onClose();
		},
		onClickClear: function() {
			if (this.value == undefined && this.value == null)
				return;
				
			for (let type in this.value.items) {
				for (let pinned_id in this.value.items[type]) {
					this.value.items[type][pinned_id] = false;
				}
			}
		},
		fetchData: async function() {
			let access_token = await DataSetManager.confirmAccessToken(this.$store);
			await this.dataset_manager[this.fetch](access_token)
				.then((data) => {
					this.$store.commit('createData', data);
				})
				.catch(async (e) => {
					let notification = null;
					switch(e.response.status) {
					case 400:
						notification = Notification.error('リクエストに失敗しました', 'notificationCreateData');
						break;
					case 401:
						notification = Notification.error('もう一度ログインしてください', 'notificationCreateData');
						this.logout();
						break;
					case 403:
						notification = Notification.error('権限がありません', 'notificationCreateData');
						this.logout();
						break;
					case 404:
						notification = Notification.error('契約者情報の取得に失敗しました', 'notificationCreateData');
						break;
					case 500:
						notification = Notification.error('情報の取得に失敗しました', 'notificationCreateData');
						break;
					case 504:
						notification = Notification.error('タイムアウトしました', 'notificationCreateData');
						break;
					default :
						notification = Notification.error('通信に失敗しました', 'notificationCreateData');
						break;
					}
					this.$store.commit('addNotification', notification);
				});
		},
		logout: function() {
			this.$store.dispatch('logout');
			this.$router.push({name: 'Login', params: { 'contractor_id': this.$route.params.contractor_id }});
		},
	},
	computed: {
		display: function() {
			return this.value !== undefined && this.value !== null;
		},
		additionalInfo: function() {
			return this.$store.getters.additionalInfo;
		},
	},
}
</script>
<style>
	.modal-window.project-info .row-group {
		height: 60px;
	}
	.modal-window.project-info .row {
		
	}
	.modal-window.project-info .label {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 16px;
	}
	.modal-window.project-info .multi-line-label {
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		font-size: 16px;
		padding-top: 1px;
	}
	.modal-window.project-info .content {
		display: flex;
		align-items: flex-start;
		font-size: 16px;
	}
	.modal-window.project-info .content-name {
		word-wrap: break-word;
		font-size: 16px;
	}
	.modal-window.project-info .modal-header-project-info {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.modal-window.project-info .btn-add-class, .modal-window.project-info .btn-add-color {
		height: 24px;
		width: 24px;
		margin: 0px;
	}
	.theme--light.v-label {
		color: #000;
	}
</style>
